import { useState } from "react";
import { isIosSafari } from "../lib/install.ts";
import { Icon } from "./Icon.tsx";

export function InstallGate() {
  const [showSteps, setShowSteps] = useState(false);
  const [copied, setCopied] = useState(false);
  const safari = isIosSafari();

  const copyCurrentLink = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  };

  return (
    <main className="install-gate">
      <section className="install-gate-card">
        <img className="install-app-icon" src="/icons/apple-touch-icon.png" alt="" />
        <h1>{safari ? "Установите Шахматы" : "Откройте в Safari"}</h1>
        <p>
          {safari
            ? "Чтобы начать игру, добавьте приложение на экран «Домой»."
            : "На iPhone приложение устанавливается из Safari. Скопируйте ссылку и откройте её там."}
        </p>

        {safari ? (
          <button className="button button-primary button-large button-full" type="button" onClick={() => setShowSteps(true)}>
            <Icon name="install" />
            Установить приложение
          </button>
        ) : (
          <button className="button button-primary button-large button-full" type="button" onClick={() => void copyCurrentLink()}>
            <Icon name={copied ? "check" : "copy"} />
            {copied ? "Ссылка скопирована" : "Скопировать ссылку"}
          </button>
        )}
        <span className="install-gate-domain">chess.akvastar.ru</span>
      </section>

      {showSteps && (
        <div className="modal-backdrop install-sheet-backdrop" role="presentation">
          <section className="modal-card install-sheet" role="dialog" aria-modal="true" aria-labelledby="install-sheet-title">
            <button className="icon-button modal-close" type="button" onClick={() => setShowSteps(false)} aria-label="Закрыть">
              <Icon name="x" />
            </button>
            <img className="install-sheet-icon" src="/icons/apple-touch-icon.png" alt="" />
            <h2 id="install-sheet-title">Установить Шахматы</h2>
            <p>Два шага в Safari:</p>
            <ol className="install-steps">
              <li>
                <span className="install-step-icon"><Icon name="ios-share" /></span>
                <span><b>Нажмите «Поделиться»</b><small>Кнопка находится в нижней панели Safari.</small></span>
              </li>
              <li>
                <span className="install-step-icon"><Icon name="add-square" /></span>
                <span><b>Выберите «На экран Домой»</b><small>Затем подтвердите кнопкой «Добавить».</small></span>
              </li>
            </ol>
            <button className="button button-primary button-large button-full" type="button" onClick={() => setShowSteps(false)}>
              Понятно
            </button>
            <small className="install-launch-note">После установки откройте иконку «Шахматы».</small>
          </section>
        </div>
      )}
    </main>
  );
}
